import { Component, computed, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UserFacade } from '@app/store/user';
import { SchoolFacade } from '@app/store/school';
import { AvatarComponent } from '@app/shared';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    imports: [RouterModule, TranslateModule, AvatarComponent],
})
export class ProfileComponent {
    private readonly userFacade = inject(UserFacade);
    private readonly schoolFacade = inject(SchoolFacade);

    private readonly user = this.userFacade.user;
    readonly fullName = computed(() => this.user()?.fullName ?? '-');
    readonly avatarSrc = computed(() => this.user()?.avatarSrc);
    readonly school = this.schoolFacade.school;

    private loadSchool = effect(() => {
        const { schoolId } = this.user() ?? {};
        if (!schoolId) return;

        this.schoolFacade.getSchool(schoolId);
        this.loadSchool.destroy();
    });
}
